import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import logo from "../../assets/logo/defra.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="relative bg-slate-950 text-white overflow-hidden">
      {/* Top gradient accent */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-500 via-eco-500 to-brand-500" />

      {/* Decorative orbs */}
      <div className="absolute -top-20 left-1/4 w-80 h-80 bg-brand-500/15 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 right-1/4 w-80 h-80 bg-eco-500/15 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="flex flex-col items-start">
            <div className="flex items-center gap-3 mb-4">
              <img src={logo} alt="Defra Logo" className="h-14 w-auto" />
              <div>
                <h3 className="font-oswald text-2xl font-bold">Defra</h3>
                <p className="text-xs text-slate-400 font-overpass">
                  PT. Defra Water Technology
                </p>
              </div>
            </div>
            <p className="text-sm text-slate-400 font-overpass leading-relaxed mb-4">
              Solusi terpercaya untuk pengolahan air bersih dan limbah cair
              dengan teknologi modern yang ramah lingkungan.
            </p>
            <div className="flex gap-3">
              <Link
                to="https://www.instagram.com/wwtspecialist/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-gradient-to-br hover:from-brand-500 hover:to-eco-500 border border-white/20 hover:border-transparent flex items-center justify-center transition-all hover:-translate-y-1"
              >
                <FontAwesomeIcon icon={faInstagram} className="text-white" />
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-oswald text-lg font-semibold mb-4 tracking-wide">
              Tautan Cepat
            </h4>
            <ul className="space-y-2 font-overpass text-sm list-none p-0">
              {[
                { label: "Tentang", href: "#AboutUs" },
                { label: "Layanan", href: "#OurServices" },
                { label: "Project", href: "#ProjectsPage" },
                { label: "Blog", href: "/blog" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    onClick={item.href === "/" ? scrollToTop : undefined}
                    className="text-slate-400 hover:text-white transition-colors inline-flex items-center gap-2 hover:no-underline no-underline group"
                  >
                    <span className="w-0 group-hover:w-3 h-px bg-brand-400 transition-all" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-oswald text-lg font-semibold mb-4 tracking-wide">
              Hubungi Kami
            </h4>
            <ul className="space-y-3 font-overpass text-sm list-none p-0">
              <li>
                <Link
                  to="https://api.whatsapp.com/send/?phone=6281211516210&text&type=phone_number&app_absent=0"
                  className="flex items-start gap-3 text-slate-400 hover:text-white transition-colors no-underline hover:no-underline"
                >
                  <span className="w-8 h-8 rounded-lg bg-eco-500/20 text-eco-400 flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347" />
                    </svg>
                  </span>
                  Calling Us via WhatsApp
                </Link>
              </li>
              <li>
                <Link
                  to="https://maps.app.goo.gl/csw7FBLqKMgk5gkw5?g_st=aw"
                  className="flex items-start gap-3 text-slate-400 hover:text-white transition-colors no-underline hover:no-underline"
                >
                  <span className="w-8 h-8 rounded-lg bg-brand-500/20 text-brand-400 flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </span>
                  Lihat Lokasi Kami
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500 font-overpass">
          <span>
            © 2024{" "}
            <span className="text-slate-300 font-semibold">PT. Defra Water Technology</span>. All Rights Reserved.
          </span>
          <span>
            Crafted by{" "}
            <Link
              to=""
              className="text-brand-400 hover:text-brand-300 no-underline hover:underline"
            >
              Deha Web Design™
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
